import {get} from '@/api/http_client'
import {api_vlog_path, api_vlogs_path, search_api_vlogs_path, transcript_api_vlog_path} from "@/routes";
import {patch} from "./http_client";

export const show = id => get({ url: api_vlog_path(id) })
export const search = q => get({url: search_api_vlogs_path(), params: {q}})
export const index = term => get({ url: api_vlogs_path() })
export const transcript = id => get({ url: transcript_api_vlog_path(id) })
export const update = (id, params) => patch({ url: api_vlog_path(id), params: { vlog: params } })
